import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { HStack } from '@/components/Layout';
import SearchInput from '@/components/SearchInput';
import { useDebouncedCallback } from '@/hooks/useDebouncedCallback';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { MyCertificationsDataTable } from './-components/MyCertificationsDataTable';
import { MyCertificationTabs } from './-components/MyCertificationTabs';
import { MyCertificationsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_individual/individual/_profile/my-profile/_layout/education-and-qualification/')({
  component: MyCertificationsPage,
  validateSearch: zodValidator(MyCertificationsSearchSchema)
});
function MyCertificationsPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'individualPages.myProfile.educationAndQualification'
  });
  useDocumentTitle(t('pageTitle'));
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  // 検索ハンドラー
  const handleFilterInput = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    navigate({
      search: prev => ({
        ...prev,
        freeText: value || undefined
      })
    });
  }, [navigate]);
  return <div className="flex flex-col gap-4 px-0 md:px-12 py-0 pb-4 md:py-5 md:flex-1 md:min-h-0">
      <div className="bg-neutral-fill/60 border border-neutral-muted-border border-t-0 rounded-b-[28px] p-5 overflow-clip md:bg-transparent md:border-0 md:rounded-none md:p-0 md:overflow-visible">
        <HStack className="gap-2 items-center">
          <MyCertificationTabs certificationType={search.certificationType} />
        </HStack>
      </div>
      <HStack className="hidden md:flex flex-wrap gap-2 justify-between items-center p-3 rounded-md bg-background border border-neutral-muted-border">
        <SearchInput key="search-input-my-certifications" className="w-full max-w-[320px] h-8" placeholder={t('filterPlaceholder')} defaultValue={search.freeText} onChange={handleFilterInput} />
      </HStack>
      <MyCertificationsDataTable />
    </div>;
}